<template>
  <div class="full-background">
    <img src="@/assets/bg2.png" alt="Background Image" class="background-image">
    <div class="content">
      <h1 style="text-align: center; font-size: 35px;">大厅</h1>
      <el-tabs v-model="activeName">
        <van-search v-model="value" placeholder="请输入搜索关键词" background="#e1f6fe" />
        <el-tab-pane label="寻物招领" name="first">
          <wd-status-tip type="collect" tip="暂无物品" v-show="foundItems.length === 0" />
          <div class="container" @click="confirmg">
            <div class="item" v-for="(foundItem, index) in foundItems" :key="index">
              <img :src="foundItem.image" alt="Found Item Image">
              <div style="display: flex; align-items: center;">
                <span
                  style="width: 25px; height: 20px; background-color: red; border-radius: 50%; color: #fff; text-align: center;">领</span>
                <p>&nbsp;&nbsp;{{ foundItem.description }}</p>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="校园失物" name="second">
          <wd-status-tip type="collect" tip="暂无物品" v-show="foundItems.length === 0"/>
          <div class="container" @click="confirmg">
            <div class="item" v-for="(item, index) in items" :key="index">
              <img :src="item.image" alt="Item Image">
              <div style="display: flex; align-items: center;">
                <span
                  style="width: 25px; height: 20px; background-color: red; border-radius: 50%; color: #fff; text-align: center;">领</span>
                <p>&nbsp;&nbsp;{{ item.details }}</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="图书漂流" name="third">
          <wd-status-tip type="content" tip="暂无物品" />
        </el-tab-pane>
        <el-tab-pane label="好事分享" name="fourth">
          <!-- <wd-status-tip type="content" tip="暂无物品" /> -->
          <div class="container">
            <div class="item">
              <img src="../assets/cat.png" alt="Left Image">
              <div style="display: flex; align-items: center;">
                <span
                  style="width: 25px; height: 20px; background-color: red; border-radius: 50%; color: #fff; text-align: center;">领</span>
                <p>&nbsp;&nbsp;小猫咪今天被好人认养！！！</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/rabbit.png" alt="Right Image">
              <div style="display: flex; align-items: center;">
                <span
                  style="width: 25px; height: 20px; background-color: red; border-radius: 50%; color: #fff; text-align: center;">领</span>
                <p>&nbsp;&nbsp;小白兔在树下被好心人救下！！</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="footer">
        <van-tabbar v-model="active">
          <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
          <van-tabbar-item icon="like-o" to="/Pay">关注</van-tabbar-item>
          <van-tabbar-item icon="comment-o " to="/Hall">大厅</van-tabbar-item>
          <van-tabbar-item icon="manager-o" to="MyLogin">我的</van-tabbar-item>
        </van-tabbar>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Hall",
  data() {
    return {
      activeName: 'first',
      active: 2,
      searchText: '',
      books: [],
      filteredBooks: [],
      search: '',
      value: '',
    }
  },
  computed: {
    items() {
      return this.$store.state.items;
    },
    foundItems() {
      return this.$store.state.foundItems;
    },

  },
  methods: {
    confirmg () {
      this.$messageBox.confirm('是否认领', '提示').then(() => {
        this.$messageBox.alert('认领成功,请联系发布者')
      })
    }
  }
};

</script>

<style scoped>
.background-image {
  position: absolute;
  top: -13%;
  width: 390px;
  /* 或者设置为固定的宽度，取决于您的设计需求 */
  height: 50%;
  /* 维持图像的原始比例，或指定一个高度 */
  z-index: -1;
  /* 图片处于内容之下 */
}

.content {
  position: relative;
  z-index: 1;
  /* 确保内容在背景图之上 */
  padding-top: 38px;
  /* 根据背景图片的高度调整 */
}

.el-tabs__nav-wrap::after {
  background-color: #e1f6fe;
}

/* .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 25px;
} */

.container {
  display: flex;
  justify-content: space-between;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
}

.item img {
  width: 70%;
}

.item p {
  display: inline;
  font-weight: bold;
  font-size: 13px;
  word-wrap: break-word;
  /* 允许单词在必要时断开 */
  overflow-wrap: break-word;
  /* 确保长单词可以在边界处断开换行 */
  text-align: justify;
  /* 使文本两端对齐 */

}
</style>


// WEBPACK FOOTER //
// src/components/Hall.vue